import { jsx as _jsx } from "react/jsx-runtime";
import BryxColors from "../../types/theme";
import { iff } from "@bryxinc/ts-utils";
import BryxButton from "../BryxButton";
const BryxToggleButton = ({ active, sx, ...rest }) => {
    return (_jsx(BryxButton, { ...rest, sx: {
            ...sx,
            backgroundColor: iff(active, BryxColors.lightBrand(3)),
            "&:hover": { backgroundColor: iff(active, BryxColors.lightBrand(3) + "!important") },
            color: iff(active, BryxColors.lightBrand(1)),
        } }));
};
export default BryxToggleButton;
